import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { Header, Loader, Tab, Segment, Responsive, Button, Icon, Form } from 'semantic-ui-react';
import NewExamTerm from './NewExamTerm';
import HistoryExamTerms from './HistoryExamTerms';
import ActiveExamTerms from './ActiveExamTerms';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import request from '../../util/request';
import { fetchCurrentAcademicYear } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentServiceExamTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            activeIndex: (localStorage.getItem('activeIndex') && localStorage.getItem('activeIndex') !== 'null') ? localStorage.getItem('activeIndex') : 0,

            addExamTerm: false,
            loading: true,
            orgUnits: [],
            orgUnit: null,
        };
        this.getExamTerms = this.getExamTerms.bind(this);
        this.addExamTerm = this.addExamTerm.bind(this);
        this.deleteExamTerm = this.deleteExamTerm.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getExamTermsForAdmin = this.getExamTermsForAdmin.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        localStorage.setItem('orgUnit', value);
        this.setState({ activeIndex: 0 });
        this.getExamTermsForAdmin();
    }

    componentDidUpdate() {
        let activeRole = localStorage.getItem('activeRole');
        let activeIndex = localStorage.getItem('activeIndex');
        // let academicYear = localStorage.getItem('academicYear');
        let orgId = localStorage.getItem('orgUnit');
        window.localStorage.removeItem('activeRole');
        window.localStorage.removeItem('activeIndex');
        window.localStorage.removeItem('orgUnit');
        localStorage.setItem('activeRole', activeRole);
        localStorage.setItem('activeIndex', activeIndex);
        // localStorage.setItem('academicYear', academicYear);
        localStorage.setItem('orgUnit', orgId);

        if (this.props.location.state !== undefined) {
            if (this.props.location.state.updated === true && this.state.addExamTerm === false) {
                toast('Uspješno ste izmijenili ispitni rok!');
            } else if (this.props.location.state.updated === false && this.state.addExamTerm === false) {
                toast('Došlo je do greške! Izmjena ispitnog roka nije uspjela.');
            }
        }
    }

    componentWillUnmount() {
        if (this.props.location.state !== undefined) {
            this.props.location.state.updated = null;
        }
    }

    componentDidMount() {
        let rectoratRoles = (localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja');

        let activeRole = localStorage.getItem('activeRole');
        let activeIndex = localStorage.getItem('activeIndex');
        let orgId = localStorage.getItem('orgUnit');
        window.localStorage.removeItem('activeRole');
        window.localStorage.removeItem('activeIndex');
        window.localStorage.removeItem('orgUnit');
        localStorage.setItem('activeRole', activeRole);
        localStorage.setItem('activeIndex', activeIndex);
        // localStorage.setItem('academicYear', academicYear);
        localStorage.setItem('orgUnit', orgId);

        if (rectoratRoles) {
            request.fetchOrgUnits()
                .then(orgUnits => this.setState({ orgUnits }));
            if (localStorage.getItem('orgUnit') && localStorage.getItem('orgUnit') !== 'null') {
                this.setState({ orgUnit: JSON.parse(localStorage.getItem('orgUnit')) });
                this.getExamTermsForAdmin();
            }
        } else {
            console.log('jjj')
            this.getExamTerms();
        }
    }

    deleteExamTerm(examTermId) {
        this.setState({ deleting: true });
        axios.delete(`/exams/delete-term/${examTermId}`)
            .then(response => {
                this.getExamTerms();
                this.setState({ deleting: false });
                toast('Uspješno ste izbrisali ispitni rok.');
            }).catch(err => {
                this.getExamTerms();
                this.setState({ deleting: false });
                if (err.response.data === 'This exam term contains exams and thus cannot be deleted!') {
                    toast('Ispitni rok sadrži ispite. Nije moguće izbrisati rok.');
                } else {
                    toast('Došlo je do greške. Ispitni rok nije izbrisan.');
                }
            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('activeIndex', activeIndex);
    }

    getExamTerms() {
        fetchCurrentAcademicYear().then(ress => {
            axios.get(`/exams/terms-for-academic-year/${ress.data.id}`)
                .then(res => {
                    const data = res.data.map(el => ({
                        ...el,
                        startDatee: moment(el.startDate).format('D. M. YYYY.'),
                        endDatee: moment(el.endDate).format('D. M. YYYY.'),
                        openDate: el.registrationOpeningDate ? moment(el.registrationOpeningDate).format('D. M. YYYY.') : null,
                    }

                    ));
                    this.setState({ data, loading: false });
                })
                .catch(err => {
                    this.setState({ error: true, });
                    console.log('Failed to fetch results');
                });
        });
    }

    getExamTermsForAdmin() {
        axios.get(`/exams/terms-for-admin/${localStorage.getItem('orgUnit')}`)
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    startDatee: moment(el.startDate).format('D. M. YYYY.'),
                    endDatee: moment(el.endDate).format('D. M. YYYY.'),
                    openDate: el.registrationOpeningDate ? moment(el.registrationOpeningDate).format('D. M. YYYY.') : null,
                }

                ));
                this.setState({ data, loading: false });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }


    addExamTerm() {
        this.getExamTerms();
        this.setState({ addExamTerm: false });
    }


    render() {
        const panes = [
            {
                menuItem: 'Aktivni ispitni rokovi',
                render: () => (<Tab.Pane as={Responsive}>
                    <ActiveExamTerms
                        data={this.state.data.filter(el => el.endDate >= moment())}
                        deleteExamTerm={this.deleteExamTerm}
                        deleting={this.state.deleting}
                    /></Tab.Pane>)
            },
            {
                menuItem: 'Prethodni ispitni rokovi',
                render: () => (<Tab.Pane as={Responsive}>
                    <HistoryExamTerms /></Tab.Pane>)
            }
        ];
        return (
            <div>

                <Header as="h1">Ispitni rokovi</Header>
                <Segment.Group raised>
                    <Segment>
                        {this.state.addExamTerm ? <Header as="h3">
                            Kreiranje ispitnog roka
                        </Header> :
                            <Header as="h3">Spisak ispitnih rokova
                            {(localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Header style={IconHeader} floated="right" >  <Button
                                    color="blue"
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={() => this.setState({ addExamTerm: true })}
                                ><Icon className="add" />
                                    Kreiraj ispitni rok
                                </Button>
                                </Header>}
                        </Header>}
                    </Segment>
                    {(localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') && <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.orgUnits}>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={this.state.orgUnit}
                                        onChange={this.handleInputChange}
                                        name="orgUnit"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                {/* <Form.Field /> */}
                                <Form.Field />
                            </Form.Group>

                        </Form>
                    </Segment>}
                    {this.state.addExamTerm && <Segment><NewExamTerm
                        addExamTerm={this.addExamTerm}
                        closeAddMode={() => this.setState({ addExamTerm: false })}
                    /></Segment>}
                    {this.state.orgUnit || (localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') ?
                        this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment>
                            : <Segment><Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} /></Segment> : ''}
                </Segment.Group>


                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/ExamTerms.js